import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BasicReadField from '../BasicReadField';
import { UserConsumer } from '../providers/UserProvider';
import { globalStyles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';
import Prefixes from './Prefixes';

const styles = () => {
  return Object.assign({
    requestHeader: {
      width: 140,
      display: 'inline-block'
    },
    requestFillin: {
      color: '#CA4F0C'
    }
  }, globalStyles);
};

class ApiManager extends Component {

  render() {

    const { classes } = this.props;
    const apiEndpoint = window.location.protocol + "//" + window.location.host;

    return (
      <UserConsumer>
        {({ subscriptions, invitations, activeSubscription }) => {
          const allSubscriptions = [...subscriptions, ...invitations];
          const subscription = allSubscriptions && allSubscriptions.find(resource => {
            if (resource.type === "Subscription" && resource.id === activeSubscription) return true;
            if (resource.type === "Invitation" && resource.subscription === activeSubscription) return true;
            return false;
          });
          const subscriptionID = subscription.type.includes("Subscription") ?
            subscription.id
            :
            subscription.subscription;
          return <Grid container spacing={2} style={{ marginBottom: '30px', maxWidth: '800px' }}>
            <Grid item xs={12}>
              <TitledPanel title="Subscription IRI">
                <BasicReadField ariaLabel="Subscription IRI" dataTest="subscription-id" fullWidth text={subscriptionID} />
              </TitledPanel>
            </Grid>
            <Grid item xs={12}>
              <TitledPanel title="API Endpoint">
                <BasicReadField ariaLabel="API endpoint" dataTest="api-endpoint" fullWidth text={apiEndpoint} />
              </TitledPanel>
            </Grid>
            <Grid item xs={12}>
              <TitledPanel title="API Target">
                <BasicReadField ariaLabel="API target" dataTest="api-target" fullWidth text={subscription.subscriptionBucket.toString()} />
              </TitledPanel>
            </Grid>
            <Grid item xs={12}>
              <TitledPanel title="Request Headers">
                <div>
                  <Typography paragraph variant="body2">Include the following headers in requests, filling in values as appropriate.</Typography>
                  <div style={{ backgroundColor: '#ffffff', padding: '3px 12px 3px 12px', borderRadius: 4 }}>
                    <pre><span className={classes.requestHeader}>Authorization:</span> Bearer <span className={classes.requestFillin}>{"{{"}token{"}}"}</span></pre>
                    <pre><span className={classes.requestHeader}>Graphologi-Target:</span> {subscription.subscriptionBucket}</pre>
                  </div>
                </div>
              </TitledPanel>
            </Grid>
            <Grid item xs={12}>
              <Prefixes isReadOnly={false} />
            </Grid>
          </Grid>;
        }}
      </UserConsumer>
    );
  }
}

ApiManager.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ApiManager);